import React, { useContext, useEffect, useState } from "react";
import { OperacionExpress } from "./Procesos/OperacionExpress";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import { AnalisisCreditoContext } from "./AnalisisCreditoScreen";
import { LoaderScreen } from "../components/LoaderScreen";
import { OperacionCoordinadorCredito } from "./Procesos/OperacionCoordinadorCredito";
import { OperacionComiteCredito } from "./Procesos/OperacionComiteCredito";
import { CreditoJohnDeereFinancial } from "./Procesos/CreditoJohnDeereFinancial";
import { RevolventeCoordinadorCredito } from "./Procesos/Revolvente/RevolventeCoordinadorCredito";
import { RevolventeComiteCredito } from "./Procesos/Revolvente/RevolventeComiteCredito";
import { AmpleacionCoordinador } from "./Procesos/Revolvente/AmpleacionCoordinador";
import { Excedente } from "./Procesos/Revolvente/Excedente";
import { AmpleacionComite } from "./Procesos/Revolvente/AmpleacionComite";
import { CreditoMhusaScreen } from "./CreditoMhusa/CreditoMhusaScreen";
import { MhusaContado } from "./CreditoMhusa/MhusaContado";
import { AnalisisCreditoPrestamoCliente } from "./AnalisisCreditoPrestamoCliente";
import { AnalisisCreditoCondicionadoTimeline } from "./AnalisisCreditoCondicionadoTimeline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CreditoJDFCondicionado } from "./Procesos/CreditoJDFCondicionado";
import { useHistory, useLocation } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import { ReestructuracionSolicitudCredito } from "./Procesos/ReestructuracionSolicitudCredito";


export const AnalisisCreditoDetalle = () => {
  const { state, setState } = useContext(AnalisisCreditoContext);
  const history = useHistory();
  const location = useLocation();
  const [roperaciones, setRoperaciones] = useState({
    titulo: "",
    ejercicio: 0,
    periodo: 0,
    linea: "",
  });
  const [data, setData] = useState({
    estado: {},
    detalle: [],
  });

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    if (location.state?.folio && state.folio !== location.state.folio) {
      setState(prev => ({ ...prev, folio: location.state.folio }));
    }
  }, [location.state]);

  useEffect(() => {
    if (!state.folio) return;
    onUpdateLineTime();
  }, [state.folio]);


  useEffect(() => {
    if (location.Roperaciones !== undefined && location.Roperaciones !== null) {
      setRoperaciones({
        titulo: location.Roperaciones.titulo,
        ejercicio: location.Roperaciones.ejercicio,
        periodo: location.Roperaciones.periodo,
        linea: location.Roperaciones.linea,
      });
    }
  }, []);

  const onUpdateLineTime = () => {
    setLoader({ ...loader, mostrar: true });
    request
      // .get(`ACTimeLine/ListadoCondicionado?folio=${location.state.folio === null || location.state.folio === undefined || location.state.folio === "" ? state.folio : location.state.folio}`)
      .get(`ACTimeLine/ListadoCondicionado?folio=${state.folio}`)

      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData({
          estado: result.estado,
          detalle: result.detalle,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
      });
  };

  const onCreditoCondicionado = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio: state.folio,
      usuario: "",
    };
    request
      .post(`SCCreditoCondicionado`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setState((prevState) => ({
          ...prevState,
          folio: result.estado.folio,
        }));
        setData({
          estado: result.estado,
          detalle: result.detalle,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
      });
  };

  const onModalComentarios = () => {
    // Mostrar confirmación antes de guardar
    Swal.fire({
      title: '¿Estás seguro de eliminarla?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-confirm-button-cancel'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        onCancelarSolicitud("R");
      }
    });
  };


  const onCancelarSolicitud = (accion) => {
    setLoader({ ...loader, mostrar: true });

    const comentarios = "Solicitud cancelada por vendedor"

    const hoy = new Date().toISOString().split('T')[0];

    const post = {
      folio: state.folio,
      accion: accion,
      comentarios: comentarios,
      fecha_pagare: hoy
    };
    request
      .post(`PanelControlSolicitudes`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        history.push({
          pathname: "/SolicitudCredito/Main", //"/SolicitudCredito/ResultadosOperacion
          state: {
            filtros: state.filtros,
          },
          Roperaciones: {
            titulo: roperaciones.titulo,
            ejercicio: roperaciones.ejercicio,
            periodo: roperaciones.periodo,
            linea: roperaciones.linea,
          },
        })
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }

  const onCancelarCreditoCondicionado = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio: state.folio,
      usuario: "",
    };
    request
      .post(`SCCreditoCondicionado/Cancelar`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setState((prevState) => ({
          ...prevState,
          folio: result.estado.folio,
        }));
        setData({
          estado: result.estado,
          detalle: result.detalle,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
      });
  };
  const ComponenProcess = () => {
    const modulo = data.estado.modulo;
    if (modulo === undefined || modulo === null) return <div></div>;
    switch (modulo) {
      case "OEX":
        return (
          <OperacionExpress
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></OperacionExpress>
        );
      case "OCF":
        return (
          <OperacionCoordinadorCredito
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></OperacionCoordinadorCredito>
        );
      case "CMH":
        return (
          <CreditoMhusaScreen
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></CreditoMhusaScreen>
        );
      case "CPC":
        return (
          <AnalisisCreditoPrestamoCliente
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></AnalisisCreditoPrestamoCliente>
        );
      case "CCC":
        return (
          <AnalisisCreditoCondicionadoTimeline
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></AnalisisCreditoCondicionadoTimeline>
        );
      case "CON":
        return (
          <MhusaContado
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></MhusaContado>
        );
      case "OCO":
        return (
          <OperacionComiteCredito
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></OperacionComiteCredito>
        );
      case "RCF":
        return (
          <RevolventeCoordinadorCredito
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></RevolventeCoordinadorCredito>
        );
      case "RCO":
        return (
          <RevolventeComiteCredito
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></RevolventeComiteCredito>
        );
      case "JDF":
        return (
          <CreditoJohnDeereFinancial
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></CreditoJohnDeereFinancial>
        );
      case "SCJ":
        return (
          <CreditoJDFCondicionado
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></CreditoJDFCondicionado>
        );
      case "ACF":
        return (
          <AmpleacionCoordinador
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></AmpleacionCoordinador>
        );
      case "ACO":
        return (
          <AmpleacionComite
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></AmpleacionComite>
        );
      case "ECF":
        return (
          <Excedente
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></Excedente>
        );
      case "RSC":
        return (
          <ReestructuracionSolicitudCredito
            data={data.detalle}
            estado={data.estado}
            upload={onUpdateLineTime}
            direccion={state.direccion}
          ></ReestructuracionSolicitudCredito>
        );
      default:
        <></>;
    }
  };

  const onRegresar = () => {
    if (state.redireccion !== undefined && state.redireccion !== null && state.redireccion !== "") {
      history.push({
        pathname: state.redireccion, //"/SolicitudCredito/ResultadosOperacion
        state: {
          folio: "",
          cliente: "",
          filtros: state.filtros,
        },
        Roperaciones: {
          titulo: roperaciones.titulo,
          ejercicio: roperaciones.ejercicio,
          periodo: roperaciones.periodo,
          linea: roperaciones.linea,
        },
      })
    }
    else {
      history.push({
        pathname: "/SolicitudCredito/Main", //"/SolicitudCredito/ResultadosOperacion
        state: {
          folio: "",
          cliente: "",
          filtros: state.filtros,
        },
        Roperaciones: {
          titulo: roperaciones.titulo,
          ejercicio: roperaciones.ejercicio,
          periodo: roperaciones.periodo,
          linea: roperaciones.linea,
        },
      })
    }
  }
  return (
    <div className="container-total-aaaaa">
      <div className="solicitud-credito-detalle-boton-container">
        <div
          className="solicitud-credito-detalle-boton-regresar"
          onClick={() => onRegresar()}
        >
          <ArrowBackIcon /> Regresar
        </div>
      </div>
      {data.estado.creadorsolicitud === true && data.estado.modulo !== "RSC" && state.direccion !== "V" && (
        <div className="solicitud-credito-detalle-boton-container-timeline-condicionado">
          <div
            className="solicitud-credito-detalle-boton-cancelar-timeline-condicionado"
            onClick={() => onModalComentarios()}
          >
            <DeleteIcon /> Cancelar Solicitud
          </div>
        </div>
      )}
      <LoaderScreen loader={loader} />
      <ComponenProcess />
    </div>
  );
};
